"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Settings_1 = __importDefault(require("configs/Settings"));
const FeatureToggleConstants_1 = require("./FeatureToggleConstants");
const request_1 = __importDefault(require("@hotmart/request"));
request_1.default.register(`${Settings_1.default.api.content}/public/v1/toggles`, {
    get: {
        [FeatureToggleConstants_1.FeatureToggleEndpointKeys.GetToggleByUnleashId]: '/:toggleName/status'
    }
});
